<template>
	<view class="per">
		<view class="per_search">
			<view class="per_search_left">
				<image src="@/static/ic_search@2x.png" mode="widthFix"></image>
				<input type="text" placeholder="搜索人员姓名/手机号" />
			</view>
			<view class="per_search_add">
				<image src="@/static/ic_new@3x.png" mode="widthFix"></image>
				<text>新增</text>
			</view>
		</view>
		<view class="per_list">
			<u-swipe-action>
				<u-swipe-action-item :options="options" v-for="(item, index) in 5" :key="index">
					<view class="per_list_item">
						<view class="per_list_item_left">
							<view class="per_list_item_left_img">
								<image src="@/static/logo@2x.png" mode="widthFix"></image>
							</view>
							<view class="per_list_item_left_info">
								<view class="per_list_item_left_info_top">
									<text class="name">徐轩栋</text>
									<image src="@/static/ic_boy@2x.png" mode="widthFix"></image>
									<text class="des">已拉黑</text>
								</view>
								<view class="per_list_item_left_info_phone">
									18855123456
								</view>
							</view>
						</view>
						<view class="per_list_item_righr">
							<image src="@/static/ic_call@2x.png" mode="widthFix"></image>
							<view class="per_list_item_righr_x"></view>
							<image src="@/static/ic_edit@2x.png" mode="widthFix"></image>
						</view>
					</view>
				</u-swipe-action-item>
			</u-swipe-action>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				options: [{
					text: '删除',
					style: {
						backgroundColor: 'red'
					}
				}]
			};
		}
	}
</script>
<style>
	page {
		background-color: #f7f7f7;
	}
</style>
<style lang="scss" scoped>
	.per {
		width: 100%;

		.per_search {
			width: 100%;
			background-color: #ffffff;
			padding: 14rpx 30rpx;
			box-sizing: border-box;
			display: flex;
			align-items: center;

			.per_search_left {
				flex: 1;
				height: 72rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				background: #F7F7F7;
				border-radius: 4rpx;
				border: 1rpx solid #F0F8F9;
				display: flex;
				align-items: center;

				image {
					flex-shrink: 0;
					width: 32rpx;
					height: 32rpx;
					margin-right: 16rpx;
				}

				input {
					flex: 1;
					height: 100%;
					font-size: 26rpx;
					font-weight: 400;
					color: #000000;
				}
			}

			.per_search_add {
				flex-shrink: 0;
				display: flex;
				align-items: center;
				margin-left: 30rpx;

				image {
					width: 16rpx;
					height: 16rpx;
					margin-right: 8rpx;
				}

				text {
					font-size: 26rpx;
					font-weight: 400;
					color: #025EEF;
				}
			}
		}

		.per_list {
			width: 100%;
			display: flex;
			flex-direction: column;
			.per_list_item {
				width: 100%;
				height: 128rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: 1rpx solid #E5E5E5;
				.per_list_item_left {
					display: flex;
					align-items: center;
					.per_list_item_left_img {
						width: 80rpx;
						height: 80rpx;
						margin-right: 20rpx;
						display: flex;
						border-radius: 50%;
						align-items: center;
						justify-content: center;
						overflow: hidden;
						image {
							width: 100%;
							height: 100%;
						}
					}
					.per_list_item_left_info {
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						.per_list_item_left_info_top {
							display: flex;
							align-items: center;
							.name {
								font-size: 30rpx;
								font-weight: 400;
								color: #222222;
								margin-right: 10rpx;
							}
							image {
								width: 30rpx;
								height: 30rpx;
								margin-right: 10rpx;
							}
							.des {
								width: 68rpx;
								height: 30rpx;
								line-height: 30rpx;
								text-align: center;
								background: #EEEEEE;
								border-radius: 4rpx;
								font-size: 20rpx;
								font-weight: 400;
								color: #999999;
							}
						}
						.per_list_item_left_info_phone {
							font-size: 26rpx;
							font-weight: 400;
							color: #999999;
						}
					}
				}
				.per_list_item_righr {
					display: flex;
					align-items: center;
					image {
						width: 48rpx;
						height: 48rpx;
					}
					.per_list_item_righr_x {
						width: 1rpx;
						height: 40rpx;
						margin: 0 30rpx;
						background-color: #E5E5E5;
					}
				}
			}
		}
	}
</style>